<div class="flex flex-column align-items-center justify-content-center">
  <p-chart
    class="cii-diagram"
    type="doughnut"
    [data]="ciiRatingChartData"
    [options]="ciiRatingChartOptions"
    [plugins]="ciiRatingChartPlugins"
    style="height: 176px; max-width: 100%; padding-top: 8px"></p-chart>
</div>
<div class="flex justify-content-center gap-4 text-sm">
  <div class="flex align-items-center gap-1"><span class="border-round-sm h-1rem inline-block w-1rem gray"></span> before voyage</div>
  <div class="flex align-items-center gap-1"><span class="border-round-sm h-1rem inline-block w-1rem black"></span> after voyage</div>
</div>
<div class="flex justify-content-between gap-4" style="margin-top: 15px">
  <div class="rating">
    <div class="title text-lg">CII Rating / AER before Voyage</div>
    <div class="flex align-items-center gap-4 mt-3 after">
      <div class="text-4xl" [ngStyle]="{ color: ciiRatingColors[ciiRatingBefore] }">
        {{ ciiRatingBefore || "" }}
      </div>

      <div class="cii-value text-xl">{{ aerBefore_gtnm !== null ? (aerBefore_gtnm | number: "1.1-1") : "NV" }} gCO<sub>2</sub>/tnm</div>
    </div>
  </div>
  <div class="text-4xl">&rarr;</div>
  <div class="rating">
    <div class="title text-lg">CII Rating / AER after Voyage</div>
    <div class="flex align-items-center gap-4 mt-3 after">
      <div class="text-4xl" [ngStyle]="{ color: ciiRatingColors[ciiRatingAfter] }">
        {{ ciiRatingAfter || "" }}
      </div>
      <div class="cii-value text-xl">{{ aerAfter_gtnm !== null ? (aerAfter_gtnm | number: "1.1-1") : "NV" }} gCO<sub>2</sub>/tnm</div>
    </div>
  </div>
</div>
